import styled from 'styled-components';

import * as Common from '../../Styles';

const Theme = Common.Theme;

export const InputGroup = Common.InputGroup;

export const TextArea = styled(Common.TextArea)``;

export const ButtonGroup = styled(Common.ButtonGroup)``;

export const Button = styled(Common.Button)``;

export const FilledErrorButton = styled(Common.FilledErrorButton)``;

export const FlexRow = styled(Common.FlexRow)``;

export const FlexColumn = styled(Common.FlexColumn)``;

export const Dialog = styled(Common.Dialog)``;

export const DialogActions = styled(Common.DialogActions)``;

export const DialogTitle = styled(Common.DialogTitle)`
	align-items: flex-start !important;
	padding: 1.25rem 1.5rem 0.5rem !important;
`;

export const DialogContent = styled(Common.DialogContent)`
	margin-top: 0 !important;
	padding: 0 1.5rem 0.5rem !important;
`;

export const CircularButton = styled(Common.CircularButton)``;

export const ReasonChipRow = styled(Common.FlexRow)`
	gap: 0.5rem;
	flex-wrap: wrap;
	margin: 0.5rem 0;
`;

export const ReasonChip = styled(Common.Chip).attrs((props) => ({
	clickable: true,
	variant: props.selected ? 'filled' : 'outlined',
}))`
	border-color: ${Theme.orange} !important;
	color: ${(props) => (props.selected ? Theme.white : Theme.orange)} !important;
	background-color: ${(props) => (props.selected ? Theme.orange : 'transparent')} !important;
`;

export const Subtitle = styled.span`
	color: ${Theme.darkGrey};
	font-size: 13px;
	margin-top: 0.4rem;
`;

export const ItemsListContainer = styled.div`
	border: 1px solid ${Theme.lightGrey};
	border-radius: 4px;
	max-height: 264px;
	overflow-y: auto;
	margin-top: 0.5rem;
`;

export const ItemsListHeader = styled.label`
	display: flex;
	align-items: center;
	gap: 0.6rem;
	background: ${Theme.container};
	padding: 0.6rem 0.85rem;
	font-size: 11.5px;
	font-weight: 600;
	letter-spacing: 0.04em;
	text-transform: uppercase;
	color: ${Theme.darkGrey};
	cursor: pointer;
	position: sticky;
	top: 0;
`;

export const ItemsListHeaderLabel = styled.span`
	flex: 1;
`;

export const ItemsListHeaderCount = styled.span`
	font-variant-numeric: tabular-nums;
`;

export const ItemRow = styled.label`
	display: flex;
	align-items: center;
	gap: 0.6rem;
	padding: 0.6rem 0.85rem;
	border-top: 1px solid ${Theme.lightGrey};
	font-size: 13.5px;
	cursor: pointer;

	${(props) => (props.unchecked ? `opacity: 0.5;` : '')}
`;

export const ItemCheckbox = styled.input.attrs({ type: 'checkbox' })`
	width: 16px;
	height: 16px;
	margin: 0;
	flex: none;
	accent-color: ${Theme.error};
	cursor: pointer;
`;

export const ItemName = styled.span`
	flex: 1;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;

	${(props) => (props.unchecked ? `text-decoration: line-through;` : '')}
`;

export const ItemStatus = styled.span`
	flex: none;
	font-size: 12px;
	font-weight: 700;
	letter-spacing: 0.03em;
	text-transform: uppercase;
	color: ${Theme.orange};
`;

export const ItemPrice = styled.span`
	flex: none;
	min-width: 3.5rem;
	text-align: right;
	font-variant-numeric: tabular-nums;
`;

export const FooterNote = styled.span`
	font-size: 12.5px;
	color: ${Theme.mediumGrey};
`;

export const SelectionWarning = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	margin-top: 0.75rem;
	font-size: 13.5px;
	font-weight: 500;
	color: ${Theme.error};
`;

export const KeepOpenNote = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	margin-top: 0.75rem;
	font-size: 13.5px;
	color: ${Theme.darkGrey};
`;
